import SectionHeading from '@/components/SectionHeading';
import CTABand from '@/components/CTABand';
import { Reveal } from '@/components/Reveal';
import { Accordion, AccordionContent, AccordionItem, AccordionTrigger } from '@/components/ui/accordion';
import { useLanguage } from '@/context/LanguageContext';

export default function Faq() {
  const { t } = useLanguage();
  const items = t('faqPage.items');
  return (
    <div className="pt-28" data-testid="faq-page">
      <section className="mx-auto max-w-4xl px-5 pt-8 lg:px-8">
        <SectionHeading eyebrow="faqPage.eyebrow" title="faqPage.title" sub="faqPage.sub" align="center" />
        <Reveal className="mt-12">
          <Accordion type="single" collapsible className="rounded-[2rem] border border-brand-line bg-white px-6 shadow-[0_40px_80px_-40px_rgba(15,23,42,0.15)]" data-testid="faq-accordion">
            {items.map((f, i) => (
              <AccordionItem key={i} value={`q-${i}`} className="border-brand-line">
                <AccordionTrigger className="text-start text-base font-bold text-brand-ink hover:text-brand-blue hover:no-underline" data-testid={`faq-trigger-${i}`}>
                  {f.q}
                </AccordionTrigger>
                <AccordionContent className="text-sm leading-loose text-brand-steel" data-testid={`faq-content-${i}`}>
                  {f.a}
                </AccordionContent>
              </AccordionItem>
            ))}
          </Accordion>
        </Reveal>
      </section>
      <div className="pt-16"><CTABand /></div>
    </div>
  );
}
